import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './bursa-api-stb-cert.reducer';
import { IBursaAPIStbCert } from 'app/shared/model/bursa-api-stb-cert.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const BursaAPIStbCert = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const bursaAPIStbCertList = useAppSelector(state => state.bursaAPIStbCert.entities);
  const loading = useAppSelector(state => state.bursaAPIStbCert.loading);
  const totalItems = useAppSelector(state => state.bursaAPIStbCert.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <h2 id="bursa-api-stb-cert-heading" data-cy="BursaAPIStbCertHeading">
        <Translate contentKey="comexApp.bursaAPIStbCert.home.title">Bursa API Stb Certs</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="primary" outline onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="comexApp.bursaAPIStbCert.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="comexApp.bursaAPIStbCert.home.createLabel">Create new Bursa API Stb Cert</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {bursaAPIStbCertList && bursaAPIStbCertList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('endpointURL')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.endpointURL">Endpoint URL</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('ecertNo')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.ecertNo">Ecert No</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('memberShortName')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.memberShortName">Member Short Name</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('sucessYN')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.sucessYN">Sucess YN</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('msg')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.msg">Msg</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('seller')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.seller">Seller</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('buyer')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.buyer">Buyer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('totalValue')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.totalValue">Total Value</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('currency')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.currency">Currency</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.price">Price</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('priceMYR')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.priceMYR">Price MYR</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('sellingTimeDate')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.sellingTimeDate">Selling Time Date</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('valueDate')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.valueDate">Value Date</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('pName')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.pName">P Name</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('pVolume')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.pVolume">P Volume</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('supplier')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.supplier">Supplier</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('volume')}>
                  <Translate contentKey="comexApp.bursaAPIStbCert.volume">Volume</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bursaAPIStbCertList.map((bursaAPIStbCert, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${bursaAPIStbCert.id}`} color="link" size="sm">
                      {bursaAPIStbCert.id}
                    </Button>
                  </td>
                  <td>{bursaAPIStbCert.endpointURL}</td>
                  <td>{bursaAPIStbCert.ecertNo}</td>
                  <td>{bursaAPIStbCert.memberShortName}</td>
                  <td>{bursaAPIStbCert.sucessYN}</td>
                  <td>{bursaAPIStbCert.msg}</td>
                  <td>{bursaAPIStbCert.seller}</td>
                  <td>{bursaAPIStbCert.buyer}</td>
                  <td>{bursaAPIStbCert.totalValue}</td>
                  <td>{bursaAPIStbCert.currency}</td>
                  <td>{bursaAPIStbCert.price}</td>
                  <td>{bursaAPIStbCert.priceMYR}</td>
                  <td>{bursaAPIStbCert.sellingTimeDate}</td>
                  <td>{bursaAPIStbCert.valueDate}</td>
                  <td>{bursaAPIStbCert.pName}</td>
                  <td>{bursaAPIStbCert.pVolume}</td>
                  <td>{bursaAPIStbCert.supplier}</td>
                  <td>{bursaAPIStbCert.volume}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${bursaAPIStbCert.id}`} size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${bursaAPIStbCert.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${bursaAPIStbCert.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="comexApp.bursaAPIStbCert.home.notFound">No Bursa API Stb Certs found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={bursaAPIStbCertList && bursaAPIStbCertList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default BursaAPIStbCert;
